export const ClientFridgeStats = (json: IClientFridgeStats): IClientFridgeStatsModel => {
	const { total_cap, total_debited, total_expired, ...rest } = json
	return {
		totalCap: total_cap,
		totalDebited: total_debited,
		totalExpired: total_expired,
		...rest,
	}
}

export const ClientFridgeSlotMetadata = (json: IClientFridgeSlotMetadata): IClientFridgeSlotMetadataModel => {
	const {
		cart_id,
		payment_id,
		promotion_id,
		effective_price,
		threshold_per_slot,
		wallet_amount,
		cart_price,
		delivery_price,
		price_without_delivery,
		...rest
	} = json
	return {
		cartID: cart_id,
		paymentID: payment_id,
		promotionID: promotion_id,
		effectivePrice: effective_price,
		thresholdPerSlot: threshold_per_slot,
		walletAmount: wallet_amount,
		cartPrice: cart_price,
		deliveryPrice: delivery_price,
		priceWithoutDelivery: price_without_delivery,
		...rest,
	}
}

export const ClientFridgeSlot = (json: IClientFridgeSlot): IClientFridgeSlotModel => {
	const { client_id, balance_after, idempotency_key, metadata, created_at, updated_at, ...rest } = json
	return {
		clientID: client_id,
		balanceAfter: balance_after,
		idempotencyKey: idempotency_key,
		metadata: metadata ? ClientFridgeSlotMetadata(metadata) : null,
		createdAt: created_at,
		updatedAt: updated_at,
		...rest,
	}
}
